import React from 'react';
import { Link } from 'react-router-dom';
import { Menu } from 'antd';
import { BookOutlined } from '@ant-design/icons';
import SubMenuIndexes from 'modules/layoutModule/enums/SubMenuIndexes';
import MenuIndexes from 'modules/layoutModule/enums/MenuIndexes';
import {
  knowledgeModulesList,
  KnowledgeSubModuleDefinition,
  NawozyTVSubModuleDefinition,
  newsModulesList,
} from 'enums/modulesDefinition';

const { SubMenu } = Menu;

export const KnowledgeMenuTab = (
  subMenuClick: any,
  setSelectedMenu: any,
  subModulesData: any,
  title: string,
  userModules: any[]
) => {
  const renderSubModules = (el: any) => {
    switch (el.id) {
      case KnowledgeSubModuleDefinition.knowledge:
        return (
          <Menu.Item
            key={MenuIndexes.KNOWLEDGE}
            onClick={(e) => setSelectedMenu([e.key])}
          >
            <Link to="/expert-articles">{el.title}</Link>
          </Menu.Item>
        );
      case KnowledgeSubModuleDefinition.addKnowledge:
        return (
          <Menu.Item
            key={MenuIndexes.KNOWLEDGE_ADD}
            onClick={(e) => setSelectedMenu([e.key])}
          >
            <Link to="/expert-articles/add">{el.title}</Link>
          </Menu.Item>
        );
      case KnowledgeSubModuleDefinition.addNawozyTV:
        return (
          <Menu.Item
            key={MenuIndexes.NAWOZY_TV_ADD}
            onClick={(e) => setSelectedMenu([e.key])}
          >
            <Link to="/nawozy-tv/add">{el.title}</Link>
          </Menu.Item>
        );
      case KnowledgeSubModuleDefinition.nawozyTV:
        return (
          <Menu.Item
            key={MenuIndexes.NAWOZY_TV}
            onClick={(e) => setSelectedMenu([e.key])}
          >
            <Link to="/nawozy-tv">{el.title}</Link>
          </Menu.Item>
        );
      case KnowledgeSubModuleDefinition.fertilizationAdd:
        return (
          <Menu.Item
            key={MenuIndexes.FERTILIZATION_ADD}
            onClick={(e) => setSelectedMenu([e.key])}
          >
            <Link to="/fertilization/add">{el.title}</Link>
          </Menu.Item>
        );
      case KnowledgeSubModuleDefinition.fertilization:
        return (
          <Menu.Item
            key={MenuIndexes.FERTILIZATION}
            onClick={(e) => setSelectedMenu([e.key])}
          >
            <Link to="/fertilization">{el.title}</Link>
          </Menu.Item>
        );
      case KnowledgeSubModuleDefinition.fertilizationScheduleAdd:
        return (
          <Menu.Item
            key={MenuIndexes.FERTILIZATION_SCHEDULE_ADD}
            onClick={(e) => setSelectedMenu([e.key])}
          >
            <Link to="/fertilization-schedule/add">{el.title}</Link>
          </Menu.Item>
        );
      case KnowledgeSubModuleDefinition.fertilizationSchedule:
        return (
          <Menu.Item
            key={MenuIndexes.FERTILIZATION_SCHEDULE}
            onClick={(e) => setSelectedMenu([e.key])}
          >
            <Link to="/fertilization-schedule">{el.title}</Link>
          </Menu.Item>
        );
      case KnowledgeSubModuleDefinition.askExpert:
        return (
          <Menu.Item
            key={MenuIndexes.ASK_EXPERT}
            onClick={(e) => setSelectedMenu([e.key])}
          >
            <Link to="/ask-expert">{el.title}</Link>
          </Menu.Item>
        );
      case KnowledgeSubModuleDefinition.askExpertAdd:
        return (
          <Menu.Item
            key={MenuIndexes.ASK_EXPERT_ADD}
            onClick={(e) => setSelectedMenu([e.key])}
          >
            <Link to="/ask-expert/add">{el.title}</Link>
          </Menu.Item>
        );
      case KnowledgeSubModuleDefinition.AGROliderAdd:
        return (
          <Menu.Item
            key={MenuIndexes.AGRO_LIDER_ADD}
            onClick={(e) => setSelectedMenu([e.key])}
          >
            <Link to="/agro-lider/add">{el.title}</Link>
          </Menu.Item>
        );
      case KnowledgeSubModuleDefinition.AGROlider:
        return (
          <Menu.Item
            key={MenuIndexes.AGRO_LIDER}
            onClick={(e) => setSelectedMenu([e.key])}
          >
            <Link to="/agro-lider">{el.title}</Link>
          </Menu.Item>
        );
      default:
        return null;
    }
  };

  const checkPermissions = knowledgeModulesList.filter((module) => {
    if (userModules.includes(module.id)) return module;
  });

  if (checkPermissions.length === 0) {
    return <></>;
  }

  return (
    <>
      <SubMenu
        icon={<BookOutlined />}
        title={title}
        onTitleClick={(e) => subMenuClick(e)}
        key={SubMenuIndexes.KNOWLEDGE}
      >
        {checkPermissions.map((module) => renderSubModules(module))}
      </SubMenu>
    </>
  );
};
